export function removeNull(o: object) {
    for (var key in o) {
        if (null === o[key]) {
            o[key] = ''
        } else if (typeof o[key] === 'object') {
            removeNull(o[key])
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Helpers/ObjectHelper.ts